import { memo } from 'react';
import { Badge, Tooltip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { MAX_VISIBLE_ACCESS_CHIPS } from '../../../constants/accessRules.js';

/**
 * Removable role/group chips: the first two, then a `+N` chip whose tooltip lists the rest
 * (`Also: …`). An overflow chip, not an ellipsis.
 *
 * @param {object} props
 * @param {Array<{ key: string, label: string }>} props.items
 * @param {(key: string) => void} props.onRemove
 */
function RoleOverflowChips({ items, onRemove }) {
  const { t } = useTranslation('people-access');
  const visible = items.slice(0, MAX_VISIBLE_ACCESS_CHIPS);
  const hidden = items.slice(MAX_VISIBLE_ACCESS_CHIPS);

  return (
    <>
      {visible.map(({ key, label }) => (
        <Badge
          key={key}
          id={key}
          size="small"
          variant="secondary"
          closable
          closeButtonAriaLabel={t('import.review.access.removeItem', { name: label })}
          onClose={onRemove}
        >
          {label}
        </Badge>
      ))}
      {hidden.length > 0 ? (
        <Tooltip
          size="compact"
          position="top"
          content={t('import.review.access.also', { items: hidden.map((item) => item.label).join(', ') })}
        >
          <Badge size="small" variant="neutral" clickable>
            {t('import.review.access.overflow', { count: hidden.length })}
          </Badge>
        </Tooltip>
      ) : null}
    </>
  );
}

export default memo(RoleOverflowChips);
